import { render, staticRenderFns } from "./RoleUserList.vue?vue&type=template&id=1b38d4ce&scoped=true&"
import script from "./RoleUserList.vue?vue&type=script&lang=js&"
export * from "./RoleUserList.vue?vue&type=script&lang=js&"
import style0 from "./RoleUserList.vue?vue&type=style&index=0&id=1b38d4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b38d4ce",
  null
  
)

export default component.exports